package com.solevo.dist.network.firebase.api.products.models

import com.solevo.dist.application.models.AllowedDeliveryLocation
import com.solevo.dist.application.models.Category
import com.solevo.dist.application.models.LoyaltyScheme
import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.ProductDescription
import com.solevo.dist.application.models.ProductDetails
import kotlinx.serialization.Serializable

@Serializable
data class FirebaseProduct(
    val productId: String = "",
    val localProductName: String? = null,
    val salesUnit: String? = null,
    val legalEntityId: String? = null,
    val descriptions: List<ProductDescription>? = null,
    val productType: String? = null,
    val productGroupId: String? = null,
    var details: ProductDetails? = ProductDetails(),
    var categories: List<Category>? = null,
    var categoryName: String? = null,
    var imageUrl: String? = null,
    val appItem: Boolean? = null,
    val maxOrderQuantity: Double? = null,
    val loyaltySchemes: List<LoyaltyScheme>? = null,
    val isReward: Boolean = false,
    val productImagesFileNames: List<String>? = null,
    val appUnit: String? = "",
    val appUnitConversionRate: Double? = null,
    val appConversionUnit: String? = "",
    val quantityInAppUnits: Double? = null,
    val allowedDeliveryLocation: List<AllowedDeliveryLocation>? = null
)

fun FirebaseProduct.toProduct(): Product {
    return Product(
        productId = productId,
        localProductName = localProductName,
        salesUnit = salesUnit,
        legalEntityId = legalEntityId,
        descriptions = descriptions,
        productType = productType,
        productGroupId = productGroupId,
        details = details,
        categories = categories,
        categoryName = categoryName,
        imageUrl = imageUrl,
        appItem = appItem,
        maxOrderQuantity = maxOrderQuantity,
        loyaltySchemes = loyaltySchemes,
        isReward = isReward,
        productImagesFileNames = productImagesFileNames,
        appUnit = appUnit,
        quantityInAppUnits = quantityInAppUnits,
        allowedDeliveryLocation = allowedDeliveryLocation,
        appConversionUnit = appConversionUnit,
        appUnitConversionRate = appUnitConversionRate
    )
}


